function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "/web_modules/react.js";
import styled from '/web_modules/styled-components.js';
import { motion } from '/web_modules/framer-motion.js';

var RefreshSvg = function RefreshSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20.3 13.43a1 1 0 0 0-1.25.65A7.14 7.14 0 0 1 12.18 19 7.1 7.1 0 0 1 5 12a7.1 7.1 0 0 1 7.18-7 7.26 7.26 0 0 1 4.65 1.67l-2.17-.36a1 1 0 0 0-1.15.83 1 1 0 0 0 .83 1.15l4.24.7h.17a1 1 0 0 0 .34-.06.33.33 0 0 0 .1-.06.78.78 0 0 0 .2-.11l.09-.11c0-.05.09-.09.13-.15s0-.1.05-.14a1.34 1.34 0 0 0 .07-.18l.75-4a1 1 0 0 0-2-.38l-.27 1.45A9.21 9.21 0 0 0 12.18 3 9.1 9.1 0 0 0 3 12a9.1 9.1 0 0 0 9.18 9A9.12 9.12 0 0 0 21 14.68a1 1 0 0 0-.7-1.25z"
  }));
};

RefreshSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
import { useState, useEffect } from '/web_modules/react.js';
import { gap } from './Layout.js';
const NewSongButtonWrap = styled(motion.button).withConfig({
  displayName: "NewSongButton__NewSongButtonWrap",
  componentId: "sc-6ymjyx-0"
})(["position:fixed;bottom:0;background:#353535;background:#237bec;width:100%;height:64px;left:0;border:none;color:white;font-size:18px;font-family:'Overpass';display:flex;justify-content:center;align-items:center;", " @media screen and (min-width:800px){position:static;margin-top:72px;width:300px;align-self:center;}svg{height:32px;width:32px;fill:#f8f8f8;}"], gap('8px', 'row'));
const fixedProps = {
  initial: {
    bottom: -64
  },
  animate: {
    bottom: 0
  },
  exit: {
    bottom: -64
  }
};
const staticProps = {
  initial: {
    y: -64
  },
  animate: {
    y: 0
  },
  exit: {
    y: -64
  }
};

const isNarrowScreen = () => window.matchMedia('screen and (max-width: 799px)');

const NewSongButtonComponent = props => {
  const [isMobile, setIsMobile] = useState(() => isNarrowScreen().matches);
  useEffect(() => {
    const query = isNarrowScreen();

    const handler = mql => setIsMobile(mql.matches);

    const isModern = ('addEventListener' in query);
    isModern ? // @ts-expect-error
    query.addEventListener('change', handler) : // @ts-expect-error
    query.addListener(handler);
    return () => isModern ? // @ts-expect-error
    query.removeEventListener('change', handler) : // @ts-expect-error
    query.removeListener(handler);
  }, []);
  return /*#__PURE__*/React.createElement(NewSongButtonWrap, _extends({}, isMobile ? fixedProps : staticProps, props, {
    title: 'Start a new match'
  }), /*#__PURE__*/React.createElement(RefreshSvg, null), /*#__PURE__*/React.createElement("span", null, "New"));
};

export const NewSongButton = styled(NewSongButtonComponent).withConfig({
  displayName: "NewSongButton",
  componentId: "sc-6ymjyx-1"
})([""]);